import { ANALYTIC_EVENTS } from "@/const/event.constants"

import type { Actions, TaskState } from "@/organisms/TaskProvider"
import type { Payload, Result } from "./open-pr.types"

export const analyticsOnStateChange =
  (actions: Actions) => (state: TaskState<Payload, Result>) => {
    const meta = state.payload?.meta
    const { APPLY_FIX_SUCCESS, APPLY_FIX_ERROR } =
      ANALYTIC_EVENTS.TRIAGE.DRAWER.SAST_FIX
    const { info } = actions.logger

    if (state.status === "success")
      info(APPLY_FIX_SUCCESS, { ...meta, prUrl: state.result?.url })
    else if (state.status === "error") info(APPLY_FIX_ERROR, meta)
  }
